import React from 'react';
import clsx from 'clsx';
import useStyles from './Button.styles';

interface IBtnProps {
  type?: 'button' | 'submit' | 'reset';
  onAction: () => void;
  color?: string;
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
}

export const Button: React.FC<IBtnProps> = ({
  type = 'button',
  onAction,
  color,
  children,
  size = 'small',
  disabled = false,
}) => {
  const classes = useStyles();
  return (
    <button
      type={type}
      className={clsx(
        classes.commonStyles,
        { [classes.blueBtn]: color === 'blue' },
        classes[size],
      )}
      onClick={() => onAction()}
      data-qa-name={(children || '').toString().toLowerCase() + '_button'}
      disabled={disabled}
    >
      <div>{children}</div>
    </button>
  );
};
